import React from 'react';
import { IHttpApi } from '@cian/http-api';
import { INotificationCenterData } from '../../../typings/window';
import { IDesktopGetNotificationsRequest } from '../../repositories/notification-center/v1/desktop-get-notifications';
import { INotificationForDesktopSchema } from '../../repositories/notification-center/entities/notification/NotificationForDesktopSchema';
import { NewChatsNotificator } from './Chat';
import { SearchesNotificator } from './Searches';
import { Favorites } from '../Favorites';
import { IHeaderV1Schema } from '../../repositories/header/entities/response/HeaderV1Schema';
import { NotificationCenter } from '../NotificationCenter';
import {
  IWebGetUserFavoritesRequest,
  IWebGetUserFavoritesResponse,
} from '../../repositories/favorites/v1/web-get-user-favorites';

export interface IGroupIconsProps {
  httpApi?: IHttpApi;
  subdomain: string;
  favLink: string;
  headerData: IHeaderV1Schema;
  baseUrl: string;
  newHeaderEnabled?: boolean;
  notificationCenterData: INotificationCenterData;
  getHasNewNotifications?(): Promise<boolean>;
  getNotifications?(parameters: IDesktopGetNotificationsRequest): Promise<INotificationForDesktopSchema[] | []>;
  markNotificationAsRead?(id: number): Promise<number | null>;
  markAllNotificationAsRead?(): Promise<void>;
  deleteAllNotifications?(): Promise<void>;
  getFavorites?(params: IWebGetUserFavoritesRequest): Promise<IWebGetUserFavoritesResponse | null>;
}

export const GroupIcons: React.FC<IGroupIconsProps> = ({
  httpApi,
  subdomain,
  favLink,
  getNotifications,
  getHasNewNotifications,
  markNotificationAsRead,
  markAllNotificationAsRead,
  deleteAllNotifications,
  getFavorites,
  headerData,
  baseUrl,
  notificationCenterData,
  newHeaderEnabled = false,
}) => {
  const isAuthenticated = headerData && headerData.isAuthenticated;

  return (
    <React.Fragment>
      {isAuthenticated && (
        <div id="header-chats-icon-new" className="c-header-messages group-icons">
          <NewChatsNotificator
            headerData={headerData}
            baseUrl={baseUrl}
            notificationsCount={headerData.notificationsCount}
          />
        </div>
      )}
      <div className="c-header-user-item group-icons" id="header-user-favourites">
        <Favorites favLink={favLink} getFavorites={getFavorites} />
      </div>
      {isAuthenticated && (
        <div id="header-user-searches" className="c-header-messages group-icons">
          <SearchesNotificator headerData={headerData} />
        </div>
      )}
      <div id="header-user-notification-center" className="c-header-notifications">
        <NotificationCenter
          newHeaderEnabled={newHeaderEnabled}
          httpApi={httpApi}
          subdomain={subdomain}
          notificationCenterData={notificationCenterData}
          getNotifications={getNotifications}
          getHasNewNotifications={getHasNewNotifications}
          markNotificationAsRead={markNotificationAsRead}
          markAllNotificationAsRead={markAllNotificationAsRead}
          deleteAllNotifications={deleteAllNotifications}
        />
      </div>
    </React.Fragment>
  );
};
